import { useState } from 'react';
import { TopToolbar, Button, useStore } from 'react-admin';
import { Settings as SettingsIcon } from '@mui/icons-material';
import { CatalogAttributesModal } from './CatalogAttributesModal';
import type { Partner } from '@src/types';

/**
 * Custom actions bar for catalog list view
 * Includes button to open catalog attributes modal
 */
export const CatalogListActions = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentPartner] = useStore<Partner | null>('currentPartner', null);
  const token = sessionStorage.getItem('token') || '';

  return (
    <>
      <TopToolbar>
        <Button
          label="Manage Attributes"
          onClick={() => setModalOpen(true)}
          startIcon={<SettingsIcon />}
        />
      </TopToolbar>

      {currentPartner && (
        <CatalogAttributesModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          partnerCode={currentPartner.code}
          token={token}
        />
      )}
    </>
  );
};
